import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

const PANEL_ID = 'poster-editor-vector-border-panel';

export const openPosterEditorVectorBorderModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_VECTOR_BORDER_MODAL,
      panelProps: {
        panelId: PANEL_ID
      },
    })
  );
};